import _classCallCheck from "/Users/michaelleach/projects/idialoguefrontend/frontend/common/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/michaelleach/projects/idialoguefrontend/frontend/common/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/michaelleach/projects/idialoguefrontend/frontend/common/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/Users/michaelleach/projects/idialoguefrontend/frontend/common/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import * as React from 'react';
import injectSheet from 'react-jss';
import cx from 'classnames';
import Hamburger from './Hamburger'; // CSS

import styles from './styles';
export var DefaultTheme = /*#__PURE__*/function (_React$Component) {
  _inherits(DefaultTheme, _React$Component);

  var _super = _createSuper(DefaultTheme);

  function DefaultTheme() {
    var _this;

    _classCallCheck(this, DefaultTheme);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      isMenuExpanded: false
    };

    _this.handleBurgerClick = function () {
      return _this.setState({
        isMenuExpanded: !_this.state.isMenuExpanded
      });
    };

    _this.handleTitleKeyPress = function (event) {
      if (event.which === 13 && event.ctrlKey) {
        _this.props.onTitleChange(event);
      }
    };

    _this.handleNavClick = function (event) {
      event.preventDefault();

      _this.setState({
        isMenuExpanded: false
      });

      _this.props.onNavClick(event);
    };

    _this.handleLogin = function (event) {
      event.preventDefault();

      _this.props.onLoginClick();

      return false;
    };

    _this.handleRegister = function (event) {
      event.preventDefault();

      _this.props.onRegisterClick();

      return false;
    };

    return _this;
  }

  _createClass(DefaultTheme, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.mode !== this.props.mode) {
        this.setState({
          isMenuExpanded: false
        });
      }
    }
  }, {
    key: "renderAuthLinks",
    value: function renderAuthLinks() {
      var _this$props = this.props,
          showAuthLinks = _this$props.showAuthLinks,
          isMobile = _this$props.isMobile;

      if (showAuthLinks) {
        return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
          className: cx({
            'slds-text-heading_small': isMobile
          }),
          onClick: this.handleLogin,
          href: "#login"
        }, "Login")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
          className: cx({
            'slds-text-heading_small': isMobile
          }),
          onClick: this.handleRegister,
          href: "#register"
        }, "Register")));
      }

      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          activePage = _this$props2.activePage,
          backgroundColor = _this$props2.backgroundColor,
          classes = _this$props2.classes,
          children = _this$props2.children,
          isEditable = _this$props2.isEditable,
          isMobile = _this$props2.isMobile,
          title = _this$props2.title,
          logo = _this$props2.logo,
          useLogoOriginalSize = _this$props2.useLogoOriginalSize,
          onTitleChange = _this$props2.onTitleChange;
      return /*#__PURE__*/React.createElement("div", {
        className: cx(classes.outerContainer, 'slds-col')
      }, /*#__PURE__*/React.createElement("div", {
        className: cx(classes.container, {
          [classes.mobile]: isMobile
        })
      }, /*#__PURE__*/React.createElement("div", {
        className: classes.previewContainer,
        style: {
          backgroundColor: backgroundColor
        }
      }, /*#__PURE__*/React.createElement("header", null, /*#__PURE__*/React.createElement(Hamburger, {
        className: classes.hamburger,
        isExpanded: this.state.isMenuExpanded,
        onClick: this.handleBurgerClick
      }), /*#__PURE__*/React.createElement("div", {
        className: classes.bannerContainer
      }, /*#__PURE__*/React.createElement("h1", {
        className: cx('slds-text-heading_large', classes.bannerHeader)
      }, logo && /*#__PURE__*/React.createElement("img", {
        src: logo,
        alt: "logo",
        className: classes.logo,
        style: {
          height: useLogoOriginalSize ? 'auto' : 35
        }
      }), /*#__PURE__*/React.createElement("span", {
        contentEditable: isEditable,
        suppressContentEditableWarning: true,
        onKeyPress: this.handleTitleKeyPress,
        onBlur: onTitleChange
      }, title))), /*#__PURE__*/React.createElement("nav", {
        className: cx(classes.navContainer, {
          [classes.show]: this.state.isMenuExpanded
        })
      }, /*#__PURE__*/React.createElement("ul", null, this.props.pages.map(function (page) {
        return /*#__PURE__*/React.createElement("li", {
          key: page.name
        }, /*#__PURE__*/React.createElement("a", {
          className: cx({
            active: page.name === activePage,
            'slds-text-heading_small': isMobile
          }),
          "data-id": page.name,
          onClick: _this2.handleNavClick,
          href: "#".concat(page.name)
        }, page.label));
      }), this.renderAuthLinks()))), /*#__PURE__*/React.createElement("div", {
        className: cx('slds-grid', classes.contents)
      }, children))));
    }
  }]);

  return DefaultTheme;
}(React.Component);
DefaultTheme.defaultProps = {
  onLoginClick: function onLoginClick() {},
  onRegisterClick: function onRegisterClick() {}
};
export default injectSheet(styles)(DefaultTheme);